import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-global-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="global-dropdown-container">
      <div class="dropdown-header">
        <span class="icon">
          <svg viewBox="0 0 24 24" width="16" height="16">
            <path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
          </svg>
        </span>
<div class="dropdown-label">
  Mine Assessment Score
</div>
        <div class="score-circle" [style.backgroundColor]="getRiskColor(getOverallScore())">{{ getDisplayScore(getOverallScore()) }}</div>
      </div>
      
      <!-- Metrics List connecting to Donut -->
      <div class="metrics-list" *ngIf="isOpen && metrics && metrics.length > 0">
        <div class="metric-item" *ngFor="let metric of metrics">
          <div class="connector-line"></div>
          <div class="arrow-right"></div>
          <div class="metric-label" [style.backgroundColor]="metric.color">{{ metric.label }}</div>
          <div
            class="metric-score"
            [style.backgroundColor]="metric.scoreColor"
            [style.color]="getScoreTextColor(metric.score)">
            {{ getDisplayScore(metric.score) }}
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

:host {
  display: block;
  height: 100%;
}

.global-dropdown-container {
  height: 100%;
  justify-content: flex-start;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 390px;
  margin: 6px auto 0;
  padding-left: 30px;
  box-sizing: border-box;
  align-items: center;
  position: relative;
}
  .dropdown-label {
  flex-grow: 0;
  background-color: #424242;
  color: white;
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
}
    
.dropdown-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-left: 7px;
  cursor: pointer;
  user-select: none;
  position: relative;
  padding-left: 0;   /* REMOVE extra shift */
}

.dropdown-header::before {
  content: '';
  position: absolute;
  left: -14px;      /* align with metric arrows */
  top: 50%;
  width: 3px;      /* SHORTER line */
  height: 2px;
  background-color: #616161;
  transform: translateY(-50%);
}
    
.icon {
  color: #757575;
  margin-right: 14px;
  display: flex;
  align-items: center;
  position: relative;
}

.icon svg {
  width: 18px;
  height: 18px;
}

    
    .custom-select {
      flex-grow: 1;
      appearance: none;
      background-color: #424242;
      color: white;
      border: none;
      padding: 12px 16px;
      font-size: 16px;
      font-weight: 500;
      border-radius: 4px;
      cursor: pointer;
      outline: none;
    }
    
    .score-circle {
      width: 30px;
      height: 30px;
      background-color: #ff5b5b;  /* Dynamic color set via [style.backgroundColor] */
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 14px;
      margin-left: 6px;
    }
    
.metrics-list {
  display: flex;
  flex-direction: column;
  gap: 50px;
  margin-left: 8px;
  position: relative;
  justify-content: flex-start;
}
    
.metrics-list::before {
  content: '';
  position: absolute;
  left: 0;
  top: -40px;
  bottom: 6px;
  width: 2px;
  background-color: #616161;
}

/* horizontal connector from vertical line to Minesite box */
.metrics-list::after {
  content: '';
  position: absolute;
  left: 0;
  top: -30px;
  width: 14px;
  height: 2px;
  background-color: #616161;
}


    
    .metric-item {
      display: flex;
      align-items: center;
      position: relative;
      padding-left: 14px;
    }
    
    .connector-line {
      position: absolute;
      left: 0;
      top: 50%;
      width: 11px;
      height: 2px;
      background-color: #616161;
    }
    
    .arrow-right {
      position: absolute;
      left: 9px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 2px solid transparent;
      border-bottom: 2px solid transparent;
      border-left: 2px solid #616161;
    }
    
    .metric-label {
      flex-grow: 1;
      padding: 8px 10px;
      border-radius: 4px;
      color: #333;
      font-weight: 500;
      font-size: 14px;
      margin-right: 8px;
    }
    
    .metric-score {
      min-width: 32px;
      text-align: center;
      padding: 8px 9px;
      border-radius: 4px;
      color: #ffffff;
      font-weight: bold;
      font-size: 14px;
    }
  `]
})
export class GlobalDropdownComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() scoreData: any;
  @Output() dropdownToggle = new EventEmitter<boolean>();

  isOpen = true; // Always open now

  selectedValue = 'minesite';

  metrics: any[] = [];

  ngOnInit() {
    // Initialize metrics with default values
    this.metrics = [
      { label: 'Revenue', score: 0, color: '#E0E0E0', scoreColor: '#BDBDBD' },
      { label: 'EBITDA', score: 0, color: '#E0E0E0', scoreColor: '#BDBDBD' },
      { label: 'Liquidity runway', score: 0, color: '#E0E0E0', scoreColor: '#BDBDBD' },
      { label: 'Commodity volatility', score: 0, color: '#D7CCC8', scoreColor: '#BDBDBD' },
      { label: 'Remaining Mine Life', score: 0, color: '#D7CCC8', scoreColor: '#BDBDBD' },
      { label: 'Mine Outlook', score: 0, color: '#D7CCC8', scoreColor: '#BDBDBD' }
    ];
  }

  ngOnChanges(changes: SimpleChanges) {
    const s = this.scoreData || {};
    const mapping = this.data?.mapping || [];

    if (mapping.length > 0) {
      this.metrics = mapping.map((m: any) => {
        const score = s[`${m.key}_score`] ?? 0;

        return {
          label: m.label,
          score: score,
          color: m.label.includes('Revenue') || m.label.includes('EBITDA') || m.label.includes('Liquidity') ? '#E0E0E0' : '#D7CCC8',
          scoreColor: this.getScoreColor(score)
        };
      });
    } else {
      // Fallback to defaults if no mapping provided
      this.metrics = [
        { label: 'Revenue', score: s['revenue_score'] ?? 0, color: '#E0E0E0', scoreColor: this.getScoreColor(s['revenue_score']) },
        { label: 'EBITDA', score: s['ebitda_score'] ?? 0, color: '#E0E0E0', scoreColor: this.getScoreColor(s['ebitda_score']) },
        { label: 'Liquidity runway', score: s['liquidity_score'] ?? 0, color: '#E0E0E0', scoreColor: this.getScoreColor(s['liquidity_score']) },
        { label: 'Commodity volatility', score: s['commodity_volatility_score'] ?? 0, color: '#D7CCC8', scoreColor: this.getScoreColor(s['commodity_volatility_score']) },
        { label: 'Remaining Mine Life', score: s['mine_life_score'] ?? 0, color: '#D7CCC8', scoreColor: this.getScoreColor(s['mine_life_score']) },
        { label: 'Mine Outlook', score: s['mine_outlook_score'] ?? 0, color: '#D7CCC8', scoreColor: this.getScoreColor(s['mine_outlook_score']) }
      ];
    }

    console.log('[GlobalDropdown] updated metrics:', this.metrics);
  }

  getScoreColor(score: any): string {
    if (score === null || score === undefined) return '#BDBDBD';
    const numScore = Number(score);
    if (!Number.isFinite(numScore) || numScore === 0) return '#BDBDBD'; // No data - grey
    // Use standardized risk level colors: low=green, medium=yellow, high=red
    if (numScore >= 5) return '#FF5454'; // High risk - lighter red for metric scores
    if (numScore > 3) return '#f0b70d'; // Medium risk - yellow/gold
    return '#1db322'; // Low risk - green
  }

  getScoreTextColor(score: any): string {
    // Return white text for all score backgrounds
    return '#ffffff';
  }

  /**
   * Get risk color based on repower_score using same logic as world-map component
   * Maps 0-10 scale to 3-band risk colors
   */
  getRiskColor(score: any): string {
    if (score === null || score === undefined) return '#1db322';
    const numScore = Number(score);
    if (numScore >= 5) return '#ff5b5b'; // High risk
    if (numScore > 3) return '#f0b70d'; // Medium risk
    return '#1db322'; // Low risk
  }

  getDisplayScore(score: any): string {
    const numeric = Number(score);
    if (!Number.isFinite(numeric)) return '0.0';
    // Show 1 decimal place WITHOUT rounding - truncate instead
    const singleDecimalWithoutRounding = Math.trunc(numeric * 10) / 10;
    return singleDecimalWithoutRounding.toFixed(1);
  }

  getOverallScore(): number {
    const scoreData = this.scoreData || {};
    const mineRiskScore = Number(scoreData['mine_risk_level_score'] ?? scoreData['mine_risk_level']);
    if (Number.isFinite(mineRiskScore)) {
      return mineRiskScore;
    }

    const overall = Number(scoreData['minesite_assessment_score']);
    if (Number.isFinite(overall)) {
      return overall;
    }

    if (!Array.isArray(this.metrics) || this.metrics.length === 0) {
      return 0;
    }

    const numericScores = this.metrics
      .map((metric: any) => Number(metric?.score))
      .filter((score: number) => Number.isFinite(score));

    if (numericScores.length === 0) {
      return 0;
    }

    return numericScores.reduce((sum: number, score: number) => sum + score, 0) / numericScores.length;
  }

  toggleDropdown() {
    // Functionality removed - keeping list static
  }
}
